module.exports = __webpack_public_path__ + "img/blog3.24dd080e.jpg";